type SocietyPermissionEntry = {
  society?: string | { _id?: string };
  permissions?: Record<string, { enabled?: boolean }>;
};

export const getSocietyPermissionSocietyId = (
  society?: string | { _id?: string }
): string | undefined => {
  if (typeof society === 'object') {
    return society?._id;
  }

  return society;
};

export const getSocietyPermissionEntry = <T extends SocietyPermissionEntry>(
  entries: T[] | undefined,
  societyId: string | undefined
): T | undefined =>
  entries?.find(
    (permission) =>
      getSocietyPermissionSocietyId(permission.society) === societyId
  );

export const areAllPermissionsEnabled = (
  entry: SocietyPermissionEntry | undefined
): boolean => {
  const permissions = entry?.permissions;

  if (!permissions) {
    return true;
  }

  return Object.values(permissions).every((permission) => permission?.enabled);
};

export const isLimitedByPermissions = (
  entries: SocietyPermissionEntry[] | undefined,
  societyId: string | undefined
): boolean => {
  const entry = getSocietyPermissionEntry(entries, societyId);

  if (!entry) {
    return false;
  }

  return !areAllPermissionsEnabled(entry);
};
